<div class="wrapper" [ngClass]="'wrapper--' + size">
  <input
    [attr.id]="controlId ?? generatedRandomId"
    [disabled]="disabled"
    [checked]="state === 'checked'"
    [class.indeterminate]="state === 'indeterminate'"
    type="checkbox"
    (change)="checkboxClicked.emit()" />
  <label [for]="controlId ?? generatedRandomId" aria-hidden="true"></label>
</div>
